package fr.frux.feature.map.site

import kotlinx.coroutines.flow.Flow

/**
 * Un arbre et un lieu ne sont jamais selectionnes ensemble : une seule fiche au bas de la carte.
 * Les gestes sur la carte reglent deja le cas, mais l'arbre peut aussi etre choisi depuis la liste,
 * la recherche ou un lien, sans passer par eux. Ne suspend jamais : a lancer dans un effet.
 */
suspend fun SiteLayerViewModel.clearSelectionWhenTreeSelected(selectedTreeId: Flow<Long?>) {
    selectedTreeId.collect { id -> if (id != null) clearSelection() }
}
